import { render, staticRenderFns } from "./mob-pure.vue?vue&type=template&id=411ccda5&scoped=true"
import script from "./mob-pure.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-pure.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-pure.vue?vue&type=style&index=0&id=411ccda5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ccda5",
  null
  
)

export default component.exports